import React, { useContext } from 'react'
import { SocialMediaProviderButton } from './social-media-provider-button'
import { CARD_BODY_COLUMN_DESCRIPTION } from '../../helpers/card-body-column-description'
import { ClientContext } from '../../context/client-context'

export const LoginProvidersButtons = ({ google, facebook, apple, state, redirectUri }) => {
  const { workflowChannel } = useContext(ClientContext)
  const encodedRedirectUri = encodeURIComponent(redirectUri)
  const encodedState = encodeURIComponent(state)
  const urlSearch = `?redirect_uri=${encodedRedirectUri}&state=${encodedState}&workflow_channel=${workflowChannel}`

  return (
    <div className="row justify-content-center">
      {google &&
        <div className={`${CARD_BODY_COLUMN_DESCRIPTION} mt-2`}>
          <SocialMediaProviderButton
            label="Continuar con Google"
            providerHref={`/federated/google${urlSearch}`}
            icon={<img className="button-logo" src="/assets/google.png" alt="google"/>}/>
        </div>
      }
      {facebook && false &&
        <div className={`${CARD_BODY_COLUMN_DESCRIPTION} mt-2`}>
          <SocialMediaProviderButton
            label="Continuar con Facebook"
            providerHref={`/federated/facebook${urlSearch}`}
            icon={<img className="button-logo" src="/assets/f_logo.svg" alt="facebook"/>}/>
        </div>
      }
      {apple &&
        <div className={`${CARD_BODY_COLUMN_DESCRIPTION} mt-2`}>
          <SocialMediaProviderButton
            label="Continuar con Apple"
            providerHref={`/federated/apple${urlSearch}`}
            icon={<i className= "fa-brands fa-apple"></i>}/>
        </div>
      }
    </div>
  )
}
